const KEY_PREFIX = "welcome_video_watched_v2";

export function welcomeVideoStorageKey(coupleId) {
  if (!coupleId) return null;
  return `${KEY_PREFIX}:${coupleId}`;
}

export function hasWelcomeVideoWatched(coupleId) {
  const key = welcomeVideoStorageKey(coupleId);
  if (!key) return false;
  return localStorage.getItem(key) === "1";
}

export function markWelcomeVideoWatched(coupleId) {
  const key = welcomeVideoStorageKey(coupleId);
  if (key) localStorage.setItem(key, "1");
}

/** Limpa flags locais do vídeo de boas-vindas (validação / dev). */
export function clearWelcomeVideoProgress(coupleId = null) {
  if (coupleId) {
    localStorage.removeItem(welcomeVideoStorageKey(coupleId));
  }
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(KEY_PREFIX) || key === "welcome_video_watched") {
      localStorage.removeItem(key);
    }
  });
}

/** Casal completo, ainda sem diagnóstico dos dois, vídeo de boas-vindas não visto neste casal. */
export function needsWelcomeVideo(coupleStore) {
  if (!coupleStore?.hasCouple) return false;
  if (!coupleStore.isComplete) return false;
  if (coupleStore.bothDiagnosed) return false;
  return !hasWelcomeVideoWatched(coupleStore.couple?.id);
}
